import React from 'react';
import { useFetchQlpMetricsDocs } from '../../Hooks/qlp_ddpcr/useFetchQlpMetricsDocs';
import SimpleTable from '../../common/SimpleTable';
import Spinner from '../../common/Spinner';



const QlpMetricsDisplayDocs = () => {

    const qlpMetricsDocsQuery = useFetchQlpMetricsDocs();
    //const docData = qlpMetricsDocsQuery?.isSuccess ? qlpMetricsDocsQuery?.data : null;
    const docData = qlpMetricsDocsQuery?.data;
    const isInitialLoading = docData === undefined || docData?.isLoading;
    const columns = [
        { label: 'Definition', field: 'Definition' },
        { label: 'Metrics', field: 'Metric' }
        // Add more column definitions here as needed
    ];
    return (
        <div>
            <div>
                {isInitialLoading || docData?.isLoading ? (
                    <div className="backdrop center-child">

                        {/* Keep this an option in-case it comes back after review of UX */
                        /* <div class="flex justify-center items-center">
                            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-green-700"></div>
                        </div>
                        <p>Fetching Data...</p> */}
                        <Spinner text="Fetchin Data..." />
                    </div>
                ) : docData?.isError ? (
                    <div>Error: API Error</div>
                ) : docData?.length > 0 ? (
                    <SimpleTable data={docData} columns={columns} />
                ) : (
                    <div>Sorry, no data generated.</div>

                )}

            </div>


        </div>
    );
};

export default QlpMetricsDisplayDocs;

